import { WeekDays } from '../../../constants';

export type Schedule = { start: string | string[]; end: string | string[] };

export type MappedSchedules = { label: Days; schedule: Schedule }[];

export type ReducedSchedule = { label: string; hours: string };

export type Schedules = {
  [key in WeekDays]: Schedule;
};

export enum Days {
  monday = 'Segunda',
  tuesday = 'Terça',
  wednesday = 'Quarta',
  thursday = 'Quinta',
  friday = 'Sexta',
  saturday = 'Sábado',
  sunday = 'Domingo',
  holiday = 'Feriados',
}

export enum OpeningDays {
  mondayToFriday = 'Segunda a Sexta:',
  mondayToSaturday = 'Segunda a Sábado:',
  mondayToSunday = 'Segunda a Domingo:',
  saturday = 'Sábado:',
  sunday = 'Domingo:',
  sundayAndHolidays = 'Domingo e Feriados:',
  holidays = 'Feriados:',
}
